import type { ReactNode } from 'react';
import EnvironmentBanner from '../EnvironmentBanner';
import PublicHeader from '../PublicHeader';
import StaticFooter from '../StaticFooter';

/**
 * The outer shell every logged-out marketing page shares (#3216, kit for
 * #3122). One source for the page frame the front door, the leaders pages and
 * the waitlist each re-expressed by hand — which is exactly how public pages
 * drift apart (the epic's own failure mode; see the gap pass,
 * `docs/canonical/audits/public-surface-unification-2026-08-27.md`).
 *
 * Renders the QA/Dev environment banner (#1448), the shared PublicHeader, a
 * `flex-1` main, and the StaticFooter. This is the FULL-BLEED shell — sections
 * own their own max-width container (see `MarketingSection`). Doc/legal pages
 * that want a constrained centered column keep using `PageLayout` instead.
 *
 * Extracted byte-identical from HomePage's `LandingPage` wrapper.
 */
export default function PublicPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-oro-bg text-text-primary flex flex-col">
      <EnvironmentBanner />
      <PublicHeader />
      <main className="flex-1">{children}</main>
      <StaticFooter />
    </div>
  );
}
